import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FaCheckCircle } from "react-icons/fa";
import { clearCart } from "../redux/winesSlice";
import "./PageOrderSuccess.css";

function PageOrderSuccess() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const order = state;

  const clearEntireCart = () => {
    dispatch(clearCart());
    localStorage.removeItem("nevinnyShopCartData");
  };

  const goHome = () => {
    clearEntireCart();
    navigate("/");
  };

  const continueShopping = () => {
    clearEntireCart();
    navigate("/shop");
  };

  const backToCart = () => {
    clearEntireCart();
    navigate("/cart");
  };

  if (!order) {
    return (
      <div className="order-success-container">
        <div className="order-success-card">
          <h2>No Order Found</h2>

          <button
            className="primary-btn"
            onClick={() => navigate("/")}
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="order-success-container">

      <div className="order-success-card">

        <FaCheckCircle className="success-icon" />

        <h1>Order Successful!</h1>

        <div className="order-details">

          <div className="detail-row">
            <span>Order Number:</span>
            <span>{order.order_id}</span>
          </div>

          <div className="detail-row">
            <span>Pickup OTP:</span>
            <span>{order.uid_no}</span>
          </div>

          <div className="detail-row">
            <span>Pickup Date:</span>
            <span>{order.dlv_dt}</span>
          </div>

          <div className="detail-row schedule-row">
            <span>Schedule:</span>

            <span className="schedule-text">
              Order Pickup available within 48 working hours
            </span>
          </div>

          <div className="detail-row total-row">
            <span>Total Amount:</span>
            <span>{order.amount}</span>
          </div>

        </div>

        <div className="button-group">

          <button
            className="primary-btn"
            onClick={goHome}
          >
            Back to Home
          </button>

          <button
            className="secondary-btn"
            onClick={continueShopping}
          >
            Continue Shopping
          </button>

          <button
            className="secondary-btn"
            onClick={backToCart}
          >
            Back to Cart
          </button>

        </div>

      </div>

    </div>
  );
}

export default PageOrderSuccess;